import { AnimatePresence, motion } from "framer-motion";
import { useTranslations } from "next-intl";
import React, { FC, Fragment, useCallback, useContext, useEffect, useState } from "react";

import IconFilters from "@/components/AvailableUnitsList/IconFilters";
import Button, { ButtonSize, ButtonTheme, ButtonVariant } from "@/components/ui/Button/Button";
// import Button, { ButtonSize, ButtonTheme, ButtonVariant } from "@/components/ui/Button/Button";
import Icon from "@/components/ui/Icon/Icon";
import { AvailableUnitContext, Params } from "@/context/AvailableUnitListContext";
import { Facet } from "@/types";

import { supportedFilters } from "./AvailableUnitsList";

const MobileFilters = () => {
  const t = useTranslations();
  const { total, params, filters } = useContext(AvailableUnitContext);
  const [currentFilter, setCurrentFilter] = useState<string>();

  useEffect(() => {
    if (currentFilter) {
      document.body.classList.add("overflow-hidden");
    } else {
      document.body.classList.remove("overflow-hidden");
    }
  }, [currentFilter]);

  const filterValues = useCallback(
    (filter: string): string => {
      if (!params[filter as keyof Params]) {
        return t(`button.label.any`);
      } else {
        return t(`aul.filter.value.${params[filter as keyof Params]}`);
      }
    },
    [t, params],
  );

  const getIconFromKey = useCallback((key: string): string => {
    switch (key) {
      case "planType":
        return "plan";
      case "unitViews":
        return "image";
      case "floor":
        return "property-type-apartment";
    }
    return "";
  }, []);

  return (
    <div className="md:hidden">
      <div className="rounded-lg bg-gray-7 px-xs mb-l">
        {(filters ?? [])
          .filter((el) => {
            const key = Object.keys(el)[0];
            return supportedFilters.includes(key);
          })
          .map((filter: Facet) => {
            const key = Object.keys(filter)[0];
            return filter[key].length > 1 ? (
              <div key={`aul-filter-mobile-trigger-${key}`}>
                <button
                  onClick={() => {
                    setCurrentFilter(key);
                  }}
                  className={`flex w-full items-center py-s font-secondary text-m border-b border-b-gray-10 last:border-b-0 gap-s justify-between`}
                >
                  <Icon size="24" name={getIconFromKey(key)} className="stroke-black grow-0" />
                  <span>{t(`aul.filter.label.${key}`)}</span>
                  <div className="flex overflow-hidden items-center gap-xxs">
                    <span className="font-medium whitespace-nowrap overflow-hidden text-ellipsis ">{filterValues(key)}</span>
                    <Icon size="24" name="caret-down" className="stroke-black grow-0" />
                  </div>
                </button>
              </div>
            ) : (
              <Fragment key={`aul-filter-mobile-trigger-${key}`} />
            );
          })}
        {(filters ?? [])
          .filter((el) => {
            const key = Object.keys(el)[0];
            return supportedFilters.includes(key);
          })
          .map((filter: Facet) => {
            const key = Object.keys(filter)[0];
            return (
              <AnimatePresence key={`aul-filter-mobile-panel-${key}-animate`}>
                {currentFilter === key && (
                  <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    transition={{ duration: 0.2 }}
                    className="fixed left-0 top-0 w-full h-dvh  z-40 flex items-end "
                    key={`aul-filter-mobile-panel-${key}-panel`}
                  >
                    <div
                      className="bg-[rgba(0,0,0,0.3)] absolute left-0 top-0 w-full h-full"
                      onClick={() => {
                        setCurrentFilter(undefined);
                      }}
                    ></div>
                    <motion.div
                      initial={{ y: 50 }}
                      animate={{ y: 0 }}
                      exit={{ y: 50 }}
                      transition={{ duration: 0.2 }}
                      className="bg-white w-full px-m py-s rounded-t-[30px] md:rounded-[30px] relative"
                    >
                      <div>
                        <div className="flex justify-between">
                          <h2 className="p-m font-primary text-m uppercase font-medium">{t(`aul.filter.label.${key}`)}</h2>
                          <Button
                            className="modal__close"
                            size={ButtonSize.MEDIUM}
                            variant={ButtonVariant.TERTIARY}
                            theme={ButtonTheme.BLACK}
                            onClick={() => setCurrentFilter(undefined)}
                          >
                            <span className="pointer-events-none">
                              <Icon name="close" size="24" title="close" className="stroke-black" />
                              <span className="sr-only">{t("button.label.closeModal")}</span>
                            </span>
                          </Button>
                        </div>
                        <div className="mx-m overflow-x-auto flex gap-m">
                          {key === "planType" && (
                            <IconFilters
                              key="aul-icon-filter-planType"
                              filter={filter}
                              closeHandler={() => {
                                setCurrentFilter(undefined);
                              }}
                            />
                          )}
                          {key === "unitViews" && (
                            <IconFilters
                              key="aul-icon-filter-unitViews"
                              filter={filter}
                              closeHandler={() => {
                                setCurrentFilter(undefined);
                              }}
                            />
                          )}
                        </div>
                      </div>
                      {/* <div className="flex justify-end p-m">
                      <Button
                        customClass="w-full"
                        size={ButtonSize.MEDIUM}
                        variant={ButtonVariant.PRIMARY}
                        theme={ButtonTheme.BLACK}
                        onClick={() => {
                          // setFilters({ value: { ...mobileFilters } });
                          // setFilterName(null);
                          // setFilterPanel(null);
                        }}
                      >
                        {t("button.label.apply")}
                      </Button>
                    </div> */}
                    </motion.div>
                  </motion.div>
                )}
              </AnimatePresence>
            );
          })}
      </div>
      <p className="text-center font-secondary text-m uppercase">{t("aul.results", { total: total })}</p>
    </div>
  );
};
export default MobileFilters;
